










import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "cprod-custom-label-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdCustomLabelComp.vue"
      ),
    "cprod-payment-method-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdPaymentMethodComp.vue"
      ),
    "cprod-auto-renew-component": () =>
      import("@/components/app/global/contractProducts/cProdAutoRenewComp.vue"),
    "cprod-billing-address-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdBillingAddressComp.vue"
      ),
    "cprod-delegates": () =>
      import("@/components/app/global/contractProducts/cProdDelegates.vue")
  }
})
export default class UpmindClientCProdSettingsView extends Vue {
  // Life-cycle methods

  private mounted() {
    this.$bus.$emit("scrollClientCProdView");
  }
}
